import * as React from 'react';
import { IndexRoute, Redirect, Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import DirectoryApp from 'bundles/directory-graphql/components/DirectoryApp';

import 'css!bundles/directory-graphql/styl/index';

const NotFound = () => import('bundles/phoenix/components/NotFound');
const Directory = () => import('bundles/directory-graphql/components/DirectoryPage');

export default (
  <Route>
    <Route path="/directory" component={DirectoryApp}>
      <IndexRoute getComponent={loadOnRoute(Directory)} />
      <Redirect from="instructors" to="/directory" />
      <Redirect from="partners" to="/directory" />
      <Route path=":resource" getComponent={loadOnRoute(Directory)} />
      <Route path="*" getComponent={loadOnRoute(NotFound)} />
    </Route>
  </Route>
);
